import React from 'react';

import { Box, Typography } from '@mui/material';

import { SuggestedActionType } from '../types';

import { formatCurrency, formatSignedCurrency, formatSignedPercent, getChangeColor } from './toursPricingUtils';

type ToursPricingRow = {
  suggested_action_type: SuggestedActionType;
  original_tour_price: number;
  suggested_price_change_percent: number;
  suggested_price_change_amount?: number | null;
  after_price: number;
};

export default function ToursPricingFormatter({ row }: { row: ToursPricingRow }) {
  const changeColor = getChangeColor(row.suggested_action_type);

  return (
    <Box sx={{ alignSelf: 'flex-start', py: 1 }}>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Original:
        </Typography>{' '}
        {formatCurrency(row.original_tour_price)}
      </Typography>
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          Change %:
        </Typography>{' '}
        <Typography component="span" variant="body2" color={changeColor} fontWeight="medium">
          {formatSignedPercent(row.suggested_price_change_percent)}
        </Typography>
      </Typography>
      {row.suggested_price_change_amount != null && (
        <Typography variant="body2">
          <Typography component="span" fontWeight="bold" variant="body2">
            Change $:
          </Typography>{' '}
          <Typography component="span" variant="body2" color={changeColor} fontWeight="medium">
            {formatSignedCurrency(row.suggested_price_change_amount)}
          </Typography>
        </Typography>
      )}
      <Typography variant="body2">
        <Typography component="span" fontWeight="bold" variant="body2">
          After:
        </Typography>{' '}
        {formatCurrency(row.after_price)}
      </Typography>
    </Box>
  );
}
